var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgApplicationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#application-icon_svg__clip0_7114_140825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.655 0L89.29 27.98l-58.655 80.99L-8 80.991 50.655 0z",
    fill: "#F4F7FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.666 13l10.124 7.332-3.666 5.062L56 18.062 59.666 13zM14.519 81.865l10.123 7.332-3.665 5.062-10.124-7.332 3.666-5.062z",
    fill: "#EAEFF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.328 28l15.186 10.998-10.998 15.186L47.33 43.186 58.328 28z",
    fill: "#E1EAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.638 46.33l15.186 10.997-10.998 15.186L72.64 61.515 83.638 46.33zM65.309 71.64l15.186 10.997-10.998 15.186L54.31 86.825 65.309 71.64z",
    fill: "#EAEFF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.999 53.31l15.186 10.998-10.998 15.185-15.186-10.997L40 53.31z",
    fill: "#E1EAF8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "application-icon_svg__clip0_7114_140825"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h100v100H0z"
  })))));
}

export default __webpack_public_path__ + "./fonts/application-icon.e2bf7854d11a546bb98b8b201c5354f3.svg";
export { SvgApplicationIcon as ReactComponent };